import { observer } from 'mobx-react-lite';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'src/hooks/AuthHook';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRoute = observer(function ({
  children,
}: PrivateRouteProps): React.JSX.Element {
  const { user: { email } = {} } = useAuth();
  const location = useLocation();

  if (!email) {
    return (
      <Navigate
        to="/"
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
});
